module.exports = __webpack_public_path__ + "static/media/ic_follow_filled.afb712f1.svg";